import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/** Route guard: renders children only when the signed-in user holds `perm`.
 *  Everyone else sees a friendly "no access" panel instead of a blank 403 screen. */
export const RequirePermission = ({ perm, children }) => {
  const { can } = useAuth();
  if (can(perm)) return children;
  return (
    <div
      className="fade-up flex min-h-[60vh] items-center justify-center px-6"
      data-testid="no-access-panel"
    >
      <div className="max-w-md border border-[#C5A059]/25 bg-[#111] px-10 py-12 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#C5A059]/10">
          <ShieldAlert className="h-7 w-7 text-[#C5A059]" />
        </div>
        <h1 className="mt-6 text-2xl font-bold text-white" data-testid="no-access-title">
          You don't have access
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          This report is limited to managers and the owner. Please see the owner if you need it.
        </p>
      </div>
    </div>
  );
};
